export default "__VITE_ASSET__D3eltGF5__"